import actionTypes from './actionTypes'

const pollActions = {
	addAnswer(questionId) {
		return {
			type: actionTypes.POLL_ADD_ANSWER,
			questionId,
		}
	},
	addReferenceMediaOpenMenu(questionId) {
		return {
			type: actionTypes.POLL_ADD_REFERENCE_MEDIA_OPEN_MENU,
			questionId,
		}
	},
	answerChange(value, questionId, answerId) {
		return {
			type: actionTypes.POLL_ANSWER_CHANGE,
			value,
			questionId,
			answerId,
		}
	},
	answerFocus(questionId, answerId) {
		return {
			type: actionTypes.POLL_ANSWER_FOCUS,
			answerId,
			questionId,
		}
	},
	answerSave(questionId) {
		return {
			type: actionTypes.POLL_ANSWER_SAVE,
			questionId,
		}
	},
	cancelPoll() {
		return {
			type: actionTypes.POLL_CANCEL_POLL,
		}
	},
	deleteAnswer(questionId, answerId) {
		return {
			type: actionTypes.POLL_DELETE_ANSWER,
			answerId,
			questionId,
		}
	},
	deleteAnswerValidationError(message) {
		return {
			type: actionTypes.POLL_DELETE_ANSWER_VALIDATION_ERROR,
			message,
		}
	},
	deleteAnswerValidationSuccess(questionId, answerId) {
		return {
			type: actionTypes.POLL_DELETE_ANSWER_VALIDATION_SUCCESS,
			questionId,
			answerId,
		}
	},
	deleteReferenceMedia(questionId, iconId) {
		return {
			type: actionTypes.POLL_DELETE_REFERENCE_MEDIA,
			questionId,
			iconId,
		}
	},
	deleteReferenceMediaSuccess(questionId) {
		return {
			type: actionTypes.POLL_DELETE_REFERENCE_MEDIA_SUCCESS,
			questionId,
		}
	},
	dragAnswer(draggedAnswer, replacedAnswer) {
		return {
			type: actionTypes.POLL_DRAG_ANSWER,
			draggedAnswer,
			replacedAnswer,
		}
	},
	dropAnswer(questionId) {
		return {
			type: actionTypes.POLL_DROP_ANSWER,
			questionId,
		}
	},
	openSettingsModal() {
		return {
			type: actionTypes.POLL_EDIT_SETTINGS,
		}
	},
	questionChange(value, questionId) {
		return {
			type: actionTypes.POLL_QUESTION_CHANGE,
			value,
			questionId,
		}
	},
	questionFocus(questionId) {
		return {
			type: actionTypes.POLL_QUESTION_FOCUS,
			questionId,
		}
	},
	questionSave(questionId) {
		return {
			type: actionTypes.POLL_QUESTION_SAVE,
			questionId,
		}
	},
	savePoll() {
		return {
			type: actionTypes.POLL_SAVE_POLL,
		}
	},
	savePollSettings(settings) {
		return {
			type: actionTypes.POLL_SAVE_SETTINGS,
			settings,
		}
	},
	savePollSuccess(redirectUrl, metrics) {
		return {
			type: actionTypes.POLL_SAVE_POLL_SUCCESS,
			redirectUrl,
			metrics,
		}
	},
	savePollError(error) {
		return {
			type: actionTypes.POLL_SAVE_POLL_ERROR,
			error,
		}
	},
	toggleMultipleOptions() {
		return {
			type: actionTypes.POLL_TOGGLE_MULTIPLE_OPTIONS,
		}
	},
	savePollSettingsError(message) {
		return {
			type: actionTypes.POLL_SAVE_SETTINGS_ERROR,
			message,
		}
	},
	savePollSettingsSuccess(message) {
		return {
			type: actionTypes.POLL_SAVE_SETTINGS_SUCCESS,
			message,
		}
	},
	cancelPollConfirm() {
		return {
			type: actionTypes.POLL_CANCEL_POLL_CONFIRM,
		}
	},
	cancelPollConfirmed() {
		return {
			type: actionTypes.POLL_CANCEL_POLL_CONFIRMED,
		}
	},
	cancelReject() {
		return {
			type: actionTypes.POLL_CANCEL_POLL_REJECTED,
		}
	},
	cancelConfirm() {
		return {
			type: actionTypes.POLL_CANCEL_POLL_CONFIRMED,
		}
	},
	nearpodPickerCancel() {
		return {
			type: actionTypes.POLL_NEARPOD_PICKER_CANCEL,
		}
	},
	questionDuplicateAndDelete(questionId, duplicateQuestionId) {
		return {
			type: actionTypes.POLL_QUESTION_DUPLICATE_AND_DELETE,
			questionId,
			duplicateQuestionId,
		}
	},
	questionUpdateError(error) {
		return {
			type: actionTypes.POLL_QUESTION_UPDATE_ERROR,
			error,
		}
	},
	questionUpdateSuccess(questionId) {
		return {
			type: actionTypes.POLL_QUESTION_UPDATE_SUCCESS,
			questionId,
		}
	},
	referenceMediaMenuOptionSelected(mediaType, questionId) {
		return {
			type: actionTypes.POLL_REFERENCE_MEDIA_MENU_OPTION_SELECTED_PICKER_OPEN,
			mediaType,
			questionId,
		}
	},
	requireUploadConfirmation(questionId) {
		return {
			type: actionTypes.POLL_UPLOAD_REQUIRE_CONFIRMATION,
			questionId,
		}
	},
	uploaderUploadSuccess(questionId, icon) {
		return {
			type: actionTypes.POLL_UPLOADER_UPLOAD_SUCCESS,
			questionId,
			icon,
		}
	},
	uploaderUploadError(error, message, questionId) {
		return {
			type: actionTypes.POLL_UPLOADER_UPLOAD_ERROR,
			error,
			message,
			questionId,
		}
	},
	uploaderValidateContentError(message, questionId) {
		return {
			type: actionTypes.POLL_UPLOADER_VALIDATE_CONTENT_ERROR,
			message,
			questionId,
		}
	},
	uploaderValidateError(message, questionId) {
		return {
			type: actionTypes.POLL_UPLOADER_VALIDATE_ERROR,
			message,
			questionId,
		}
	},
	uploaderValidateSuccess(questionId, uploadId) {
		return {
			type: actionTypes.POLL_UPLOADER_VALIDATE_SUCCESS,
			questionId,
			uploadId,
		}
	},
	uploadReferenceMedia(allowedTypes, files, questionId, featureType, force) {
		return {
			type: actionTypes.POLL_UPLOAD_REFERENCE_MEDIA,
			allowedTypes,
			files,
			questionId,
			featureType,
			force,
		}
	},
	uploadReferenceMediaError(message, questionId) {
		return {
			type: actionTypes.POLL_UPLOAD_REFERENCE_MEDIA_ERROR,
			message,
			questionId,
		}
	},
	validationError(message) {
		return {
			type: actionTypes.POLL_VALIDATION_ERROR,
			message,
		}
	},
	validationSuccess(text) {
		return {
			type: actionTypes.POLL_VALIDATION_SUCCESS,
			text,
		}
	},
	initializePollSuccess(data) {
		return {
			type: actionTypes.POLL_INITIALIZE_SUCCESS,
			data,
		}
	},
	initializePollError() {
		return {
			type: actionTypes.POLL_INITIALIZE_ERROR,
		}
	},
	addTimer() {
		return {
			type: actionTypes.POLL_ADD_TIMER,
		}
	},
	editTimer() {
		return {
			type: actionTypes.POLL_EDIT_TIMER,
		}
	},
	deleteTimer() {
		return {
			type: actionTypes.POLL_DELETE_TIMER,
		}
	},
	saveTimer(value) {
		return {
			type: actionTypes.POLL_SAVE_TIMER,
			value,
		}
	},
	cancelTimer() {
		return {
			type: actionTypes.POLL_CANCEL_TIMER,
		}
	},
}

export default pollActions
